import React, { Children } from 'react';
import { XCircle } from 'lucide-react';
import { motion } from 'framer-motion';
import { FadeIn } from './FadeIn';
const failures = ['Las pastillas para dormir te fuerzan a la inconsciencia, pero bloquean las fases de sueño profundo y reparador.', 'Los suplementos genéricos no consideran los picos de cortisol nocturno típicos de la menopausia.', 'Intentar "forzarte" a dormir activa la respuesta de estrés, manteniéndote alerta por pura biología.', 'El "higiene de sueño" estándar ignora el factor número uno en mujeres mayores: la regulación térmica celular.'];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    x: -20
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function FailedSolutions() {
  return <section className="py-14 px-4 bg-navy-800/30" data-id="element-6">
      <div className="max-w-4xl mx-auto" data-id="element-7">
        <FadeIn data-id="element-8">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-center text-warmWhite-100 mb-8" data-id="element-9">
            Por qué lo que has intentado{' '}
            <span className="text-red-400/80 italic" data-id="element-10">no funcionó</span>
          </h2>
        </FadeIn>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="space-y-3" data-id="element-11">
          {failures.map((text, index) => <motion.div key={index} variants={itemVariants} className="glass-card rounded-xl p-4 flex items-start gap-3" data-id="element-12">
              <XCircle className="w-5 h-5 text-red-400/80 shrink-0 mt-1" strokeWidth={1.5} data-id="element-13" />
              <p className="text-base text-warmWhite-200 leading-relaxed" data-id="element-14">
                {text}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}